import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {PluginFilter, PluginSettings} from '../abstract-data-api-plugin';
import bootstrap from 'bootstrap';

interface LawyerFilter extends PluginFilter {
}

interface LawyerSettings extends PluginSettings {
}

export {LawyerFilter, LawyerSettings};

/**
 * Lawyer filter.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Filter extends AbstractFilter<LawyerFilter, LawyerSettings> {
  private expertisesFilterModal: HTMLDivElement | null = null;

  constructor(container: HTMLElement) {
    super(container, 'lawyer', {
      position: 0,
      expertise: 0
    } as LawyerFilter);
    DataApi.instance.lawyerEndpoint.distinctValues(this.settings)
      .then(response => {
        const template = require('../../handlebars/templates/lawyer/filter.handlebars');
        const html = template({
          distinctValues: response,
          filter: this.filter
        });
        this.update(html);
        this.initializeResult();

        // Move modal outside before the closing body tag, so that z-index and proper overlay is guaranteed
        this.expertisesFilterModal = this.container.querySelector<HTMLDivElement>('#expertises-filter-modal');
        if (this.expertisesFilterModal) {
          document.body.append(this.expertisesFilterModal);
          this.changeExpertisesFilterModalButtonText(this.expertisesFilterModal, this.filter);
        }

        ComponentRegistry.add('lawyer-filter', this);
      })
      .catch(e => {
        this.error(e);
      });

    this.emitter.on('change', filter => {
      if (this.expertisesFilterModal) {
        const modal = bootstrap.Modal.getOrCreateInstance(this.expertisesFilterModal);
        modal.hide();
        this.changeExpertisesFilterModalButtonText(this.expertisesFilterModal, filter);
      }
    });
  }

  /**
   * Changes the text for opening the expertise filter modal to fit the given filter.
   *
   * @param {HTMLDivElement} expertisesFilterModal
   * @param {LawyerFilter} filter
   */
  private changeExpertisesFilterModalButtonText(expertisesFilterModal: HTMLDivElement, filter: LawyerFilter): void {
    const modalButtonText = document.querySelector('button[data-bs-target="#expertises-filter-modal"] [data-text]');
    const expertiseButton = expertisesFilterModal.querySelector(`[data-value="${filter.expertise}"]`);
    if (!modalButtonText || !expertiseButton) {
      return;
    }
    const expertiseButtonContainer = expertiseButton.parentElement?.parentElement;
    if (!expertiseButtonContainer) {
      return;
    }
    const expertiseButtonText = expertiseButtonContainer.querySelector('[data-text]');
    if (expertiseButtonText) {
      modalButtonText.textContent = expertiseButtonText.textContent;
    }
  }
}
